import type { ReactNode } from "react";
import { Navigate, useSearchParams } from "react-router";

import { safeNext } from "@/app/session/safeNext";
import { useSession } from "@/app/session/useSession";

/** Public auth screens: once a session exists, go where the person asked to be. */
export function GuestOnly({ children }: { children: ReactNode }) {
  const { state } = useSession();
  const [params] = useSearchParams();
  if (state.status === "signed-in") return <Navigate to={safeNext(params.get("next"))} replace />;
  return children;
}
